import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {styled} from "@mui/material/styles";

import AddIcon from "components/icons/AddIcon";

CreateOptionLabel.propTypes = {
    value: PropTypes.string.isRequired,
};

const Container = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
});

// currentColor keeps the circle and the icon aligned with the option text color
const IconCircle = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    flexShrink: 0,
    border: '1px solid currentColor',
    borderRadius: '50%',
});

export default function CreateOptionLabel({value}) {
    return (
        <Container>
            <IconCircle>
                <AddIcon size={14} color={'currentColor'} />
            </IconCircle>
            <FormattedMessage id={'mapper.select.create'} values={{value}} />
        </Container>
    );
}
